import "./Button_module.css";
const Button_module_rslib_entry_ = {
    button: "button-UGhzQm",
    primary: "primary-gpQ7Mi",
    shadow: "shadow-RQWwk4",
    secondary: "secondary-bjc5zI",
    ternary: "ternary-fx6Qkp",
    link: "link-B7vfkw",
    small: "small-bHJz7H",
    large: "large-s4jr3J"
};
export { Button_module_rslib_entry_ as default };

//# sourceMappingURL=Button.module.js.map